// Virtual "Transform" lane contract for 2D/text strips.
//
// This is intentionally NOT the same as the real SmartKeys `transform` group (matrix),
// because the evaluator gives `smartKeys.transform` precedence and would suppress
// per-axis groups like `position.x` / `position.y`.
//
// Instead, we use a virtual envelopeProp (`transform2d`) that:
// - reads timing (offsets) from a canonical per-axis group (position.x)
// - writes the same timing to all linked per-axis groups (position/scale/rotation)
// - keeps value editing per-axis (dots/sliders) unchanged

export const TRANSFORM2D_ENVELOPE_PROP = 'transform2d'

// Canonical group for offsets/time handles (Start/Left/Right/End timing).
export const TRANSFORM2D_CANONICAL_PROP = 'position.x'

// Per-axis groups that should share the same timing skeleton.
export const TRANSFORM2D_LINKED_PROPS = [
  'position.x',
  'position.y',
  'scale.x',
  'scale.y',
  'rotation.z',
]

export function isTransform2dEnvelopeProp(prop) {
  return prop === TRANSFORM2D_ENVELOPE_PROP
}

export function getTransform2dCanonicalProp() {
  return TRANSFORM2D_CANONICAL_PROP
}

export function getTransform2dLinkedProps() {
  return [...TRANSFORM2D_LINKED_PROPS]
}

